import { useEffect, useState } from 'react';
import PrizeCardWithTitleBelow from '../PrizeCardWithTitleBelow';
import Router from 'next/router';
import { prizeApiClient } from 'utils/apiClient';
import { PrizeV2 as Prize } from 'types/Prize';
import { TGetSimilarPrizesResponse } from '@daymade/api-contracts';
import AboutUsModule from 'components/about-us/AboutUsModule';
import AboutUsSiteContainer from 'components/about-us/AboutUsSiteContainer';
import useEmblaCarousel from 'embla-carousel-react';
import CarouselButtons from 'components/carousel2025/CarouselButtons';
import styles from './PrizeRecommendationSection.module.css';
import EmblaCarousel from 'components/carousel2025/EmblaCarousel';

interface IPrizeRecommendationSectionProps {
  prizeId: Prize['id'];
}

export const PrizeRecommendationSection = ({
  prizeId,
}: IPrizeRecommendationSectionProps) => {
  const [recommendedPrizes, setRecommendedPrizes] =
    useState<TGetSimilarPrizesResponse>([]);
  const emblaCarouselInfo = useEmblaCarousel({ loop: false, duration: 10, inViewThreshold: 0.1 }, );

  useEffect(() => {
    (async () => {
      if (prizeId) {
        const resp = await prizeApiClient.public.getSimilarPrizes({
          query: {
            prizeId,
          },
        });

        let similarPrizes: TGetSimilarPrizesResponse = [];

        switch (resp.status) {
          case 200:
            similarPrizes = resp.body;
            break;
          default:
            console.error(
              `Error fetching similar prizes (id: ${prizeId}):`, resp.body
            );
            break;
        }

        setRecommendedPrizes(similarPrizes);
      }
    })();
  }, [prizeId]);
  return (
    <AboutUsModule background="tealGradient">
      <AboutUsSiteContainer>
        <h2 className="aboutUsTypographyHeaderXlarge" id="recommendation">You might also like...</h2>
        <div className={styles.carouselContainer}>
          <EmblaCarousel className={styles.headerImageCarousel}
            emblaCarouselInfo={emblaCarouselInfo}
            hidePips
            items={recommendedPrizes.map((recommendedPrize, index) => 
              <div key={index} className={styles.carouselImage}>
                <PrizeCardWithTitleBelow
                  rebrandDm2025
                  key={index}
                  prize={recommendedPrize}
                  onClick={(event) => {
                    Router.push(`/prizes/details/${recommendedPrize.slug}`);
                    event.preventDefault();
                  } }
                  href={`/prizes/details/${recommendedPrize.slug}`} withFavouriteButton showLockedPrizeBannerIfApplicable={false}
                />
              </div>
            )}
          />
          <CarouselButtons changeSelectedIndex={x=> x < 0 ? emblaCarouselInfo[1]?.scrollPrev() : emblaCarouselInfo[1]?.scrollNext()  } />
        </div>
      </AboutUsSiteContainer>
    </AboutUsModule>
  );
};
